import axiosPlataformaClient from '../../../plugins/axios.plataforma.plugin';

export default {
  getContextAndMenu(enrollmentId) {
    return axiosPlataformaClient.custAxios().get(`/content/enrollment/${enrollmentId}`);
  }
};
